module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/bg-2m-894c9a83f81e871302a90b60de083269.png";